import React, { useEffect, useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import icon from "../../../../Images/smile.svg";

const AdminPieChart = ({ totalSold,totalTickets }) => {
  const soldTickets = Number(totalSold);
  const tickets = Number(totalTickets);
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));

  const remainingTickets = tickets - soldTickets;

  const StyledText = styled("text")(({ theme }) => ({
    fill: theme.palette.text.primary,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: isMobile ? 14 : isTablet ? 18 : 22,
    fontWeight: "bolder",
  }));

  function PieCenterLabel({ children }) {
    const { width, height } = useDrawingArea();
    const adjustedHeight = isMobile
      ? height / 4.5
      : isTablet
      ? height / 5
      : isDesktop
      ? height / 6
      : isLg
      ? height / 10
      : height / 10;
    return (
      <StyledText x={width / 2} y={adjustedHeight}>
        {children}
      </StyledText>
    );
  }

  const data = [
    { name: "Sold Tickets", value: soldTickets, color: "#2D6F8C" },
    { name: "Remaining Tickets", value: tickets, color: "#E0E1DD" },
  ];

  const soldTicketsNumHeight = isMobile ? "0.8em" : isTablet ? "1.4em" : "1.5em";

  const getDimensions = () => {
    if (isMobile) {
      return {
        width: 250,
        height: 250,
        outerRadius: 60,
        innerRadius: 50,
        cx: 120,
        cy: 70,
        iconSize: 24,
        iconX: 113,
        iconY: 35,
      };
    } else if (isTablet) {
      return {
        width: 280,
        height: 280,
        outerRadius: 75,
        innerRadius: 60,
        cx: 135,
        cy: 83,
        iconSize: 28,
        iconX: 125,
        iconY: 30,
      };
    } else if (isDesktop) {
      return {
        width: 280,
        height: 280,
        outerRadius: 65,
        innerRadius: 70,
        cx: 140,
        cy: 90,
        iconSize: 28,
        iconX: 125,
        iconY: 30,
      };
    } else if (isLg) {
      return {
        width: 280,
        height: 280,
        outerRadius: 75,
        innerRadius: 60,
        cx: 140,
        cy: 50,
        iconSize: 28,
        iconX: 112,
        iconY: 30,
      };
    } else {
      return {
        width: 300,
        height: 300,
        outerRadius: 92,
        innerRadius: 70,
        cx: 150,
        cy: 70,
        iconSize: 32,
        iconX: 135,
        iconY: 15,
      };
    }
  };

  const {
    width,
    height,
    outerRadius,
    innerRadius,
    cx,
    cy,
    iconSize,
    iconX,
    iconY,
  } = getDimensions();

  return (
    <Box
      position="relative"
      display="inline-flex"
      width="100%"
      justifyContent="center"
    >
      <PieChart
        series={[
          {
            data: data.map((item, index) => ({
              ...item,
              outerRadius: index === 1 ? outerRadius : outerRadius,
            })),
            innerRadius: innerRadius,
            paddingAngle: 2,
            cornerRadius: 20,
            startAngle: 2,
            endAngle: 360,
            cx: cx,
            cy: cy,
          },
        ]}
        width={width}
        height={height}
      >
        
        <PieCenterLabel>
          <tspan dy="-1.5em">
            <image
              href={icon}
              width={iconSize}
              height={iconSize}
              style={{ verticalAlign: "middle" }}
            />
          </tspan>
          <tspan
            style={{ fontSize: 30, fontWeight: 700 }}
            x="51%"
            dy={soldTicketsNumHeight}
          >
            {soldTickets}
          </tspan>
        </PieCenterLabel>
      </PieChart>
    </Box>
  );
};

export default AdminPieChart;
